<template>
  <div class="data-row" :class="[((rowIndex) % 2 === 0) ? 'odd' : 'even']">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'row',
  props: {
    props: {
      type: Object
    }
  },
  computed: {
    rowIndex () {
      return this.props.index
    },
    data () {
      return this.props.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/table/row/Row.vue